export enum Team {
    Accounts = 'accounts',
    Admin = 'admin',
    Connectivity = 'connectivity',
    Data = 'data',
    Distribution = 'distribution',
    Finance = 'finance',
    Guests = 'guests',
    Infrastructure = 'infrastructure',
    Internal = 'internal',
    Merchant = 'merchant',
    Optimus = 'optimus',
    Productivity = 'productivity',
    Quality = 'quality',
    Reservations = 'reservations',
    Spaces = 'spaces',
    Tooling = 'tooling',
}
